import React from 'react';

const HomePageCaseStudy2 = ({ ...props }) => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 324 324"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M317.319 324H6.68086C4.90899 324 3.20968 323.296 1.95677 322.043C0.703869 320.79 0 319.091 0 317.319V6.68086C0 4.90899 0.703869 3.20968 1.95677 1.95677C3.20968 0.703869 4.90899 0 6.68086 0H317.319C319.091 0 320.79 0.703869 322.043 1.95677C323.296 3.20968 324 4.90899 324 6.68086V317.319C324 319.091 323.296 320.79 322.043 322.043C320.79 323.296 319.091 324 317.319 324Z"
      fill="#69A8EB"
    />
  </svg>
);

export default HomePageCaseStudy2;
